/**
 * Date and time format constants for business line shipping dates
 */
export const DATE_FORMATS = {
  /** Format: 'Monday, 31/12/24' */
  DATE_WITH_DAY: 'EEEE, dd/MM/yy',
  /** Format: '31/12/2024' */
  DATE_DISPLAY: 'dd/MM/yyyy',
  /** Format: '2024-12-31' (ISO date) */
  DATE_ISO: 'yyyy-MM-dd',
  /** Format: '14:30' (24-hour time) */
  TIME_24H: 'HH:mm',
} as const;

export const LOCALE = {
  SPANISH: 'es',
  SPANISH_ES: 'es-ES',
  ENGLISH: 'en',
} as const;

export const TIME_SUFFIX = {
  DAY_START: 'T00:00:00',
  DAY_END: 'T23:59:59',
} as const;

export const UI_TEXT = {
  NO_DATE_ASSIGNED: 'Sin fecha asignada',
  PLACEHOLDER: '-',
} as const;
